var cache = {};
var deps = {
    'facebook': ('https:' == document.location.protocol ? 'https://' : 'http://') + 'connect.facebook.net/en_US/sdk.js',
    'instagram': ('https:' == document.location.protocol ? 'https://' : 'http://') + 'platform.instagram.com/en_US/embeds.js'
};

/*
@desc inject script async into dom
@param url, the url of the dependency
@param callback, gets invoked as soon as the dependency is loaded
*/
var inject = function(url, cb) {

    var entry, script;
    script = document.createElement('script');
    script.async = true;
    script.type = "text/javascript";
    script.src = url;
    entry = document.getElementsByTagName('script')[0];
    entry.parentNode.insertBefore(script, entry);
    script.onload = script.onreadystatechange = function() {
        var rdyState = script.readyState;

        if (!rdyState || /complete|loaded/.test(script.readyState)) {
            if (typeof cb === "function") {
                cb()
            }
            script.onload = null;
            return script.onreadystatechange = null;
        }
    }
}

module.exports = {

    use: function(name, cb) {

        if (cache[name]) {
            typeof cb === 'function' && cb()
        } else {
            inject(deps[name], function() {
                cache[name] = true;
                typeof cb === 'function' ? cb() : void 0
            })
        }
    }
}
